import { createStore } from 'vuex'

export default createStore({
    state: {
        display_form_popup: false
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})